import moment from 'moment';

export const URL_DATE_FORMAT = 'YYYY-MM-DD';
export const PAGE_SIZE = 20;

export const CICLO_ATUAL = 'ATUAL';
export const CICLO_PASSADO = 'PASSADO';
export const CICLO_CUSTOM = 'CUSTOM';

export const CICLOS = [
  { id: CICLO_ATUAL, nome: 'Atual' },
  { id: CICLO_PASSADO, nome: 'Passado' },
  { id: CICLO_CUSTOM, nome: 'Custom' },
];

const SEVERIDADE_RANK = { ALTA: 0, MEDIA: 1, BAIXA: 2 };

export const TIPOS = {
  HISTORICO_ORFAO: { chip: 'Inspeção s/ registro', label: 'Inspeção sem registro' },
  CAMPO_SEM_PONTO: { chip: 'Inspeção s/ ponto', label: 'Inspeção sem ponto' },
  JORNADA_FORA_DA_REGUA: { chip: 'Fora da régua', label: 'Jornada fora da régua' },
  INTERMITENTE_SEM_CONVOCACAO: { chip: 'Sem convocação', label: 'Trabalhou sem convocação' },
  INTERMITENTE_PROGRAMADO_SEM_CONVOCACAO: { chip: 'Prog. s/ convocação', label: 'Programado sem convocação' },
  USO_MUTUO_CONTROLE_FALTANTE: { chip: 'Uso mútuo s/ controle', label: 'Uso mútuo sem controle' },
  JORNADA_SEM_PROGRAMACAO: { chip: 'S/ Programação', label: 'Ponto sem programação' },
  INTERMITENTE_SEM_PONTO: { chip: 'Sem ponto', label: 'Convocado sem ponto' },
  PROGRAMACAO_SEM_REGISTRO: { chip: 'S/ Registro', label: 'Programado sem registro' },
  CONTROLE_SEM_USO_MUTUO: { chip: 'Controle s/ Uso Mútuo', label: 'Controle sem uso mútuo' },
  AUSENCIA_JUSTIFICADA_COM_ATIVIDADE: { chip: 'Ausência c/ atividade', label: 'Ausência com atividade' },
};

export const LEGENDA_CLASSIFICACAO = [
  {
    codigo: 'HISTORICO_ORFAO',
    severidade: 'ALTA',
    significa: 'Trabalhou na inspeção neste dia e não há programação, ponto nem convocação. A inspeção ficou sem nenhum registro administrativo.',
  },
  {
    codigo: 'JORNADA_SEM_PROGRAMACAO',
    severidade: 'MEDIA',
    significa: 'Registrou ponto ou controle de jornada, mas não havia programação para aquele dia.',
  },
  {
    codigo: 'JORNADA_FORA_DA_REGUA',
    severidade: 'ALTA',
    significa: 'Registrou ponto num dia em que o regime não espera trabalho: domingo ou feriado, no indeterminado, ou fora do período da convocação, no intermitente.',
  },
  {
    codigo: 'INTERMITENTE_SEM_CONVOCACAO',
    severidade: 'ALTA',
    significa: 'Intermitente registrou ponto sem ter uma convocação aceita cobrindo o dia.',
  },
  {
    codigo: 'INTERMITENTE_PROGRAMADO_SEM_CONVOCACAO',
    severidade: 'ALTA',
    significa: 'Intermitente entrou na programação sem convocação aceita cobrindo o dia. Foi alocado sem ter sido chamado.',
  },
  {
    codigo: 'INTERMITENTE_SEM_PONTO',
    severidade: 'MEDIA',
    severidadeNota: 'Alta se também fez a inspeção',
    significa: 'Intermitente foi convocado e não registrou o ponto. A severidade sobe para alta quando também há inspeção nesse dia.',
  },
  {
    codigo: 'USO_MUTUO_CONTROLE_FALTANTE',
    severidade: 'ALTA',
    significa: 'Houve inspeção de uso mútuo no dia e falta o controle de jornada correspondente.',
  },
  {
    codigo: 'CONTROLE_SEM_USO_MUTUO',
    severidade: 'BAIXA',
    significa: 'Existe controle de jornada no dia e não há inspeção de uso mútuo. O controle ficou sem o uso mútuo.',
  },
  {
    codigo: 'PROGRAMACAO_SEM_REGISTRO',
    severidade: 'MEDIA',
    significa: 'Estava na programação, não registrou ponto e não há inspeção. Não há evidência de que trabalhou.',
  },
  {
    codigo: 'CAMPO_SEM_PONTO',
    severidade: 'ALTA',
    significa: 'Trabalhou na inspeção e estava na programação, mas não registrou o ponto.',
  },
  {
    codigo: 'AUSENCIA_JUSTIFICADA_COM_ATIVIDADE',
    severidade: 'ALTA',
    significa: 'A folha marca ausência (férias, folga, licença ou aguardando serviço) no mesmo dia em que há programação, convocação ou inspeção.',
  },
];

export const FONTES = [
  { key: 'temConvocacao', label: 'Convocação', href: '/v2/convocacoes', idParam: 'inspetorId' },
  { key: 'temProgramacao', label: 'Programação', href: '/v2/programacao-diaria-dia', idParam: 'usuarioId' },
  { key: 'temFolhaPonto', label: 'Ponto', href: '/v2/jornada', idParam: 'usuarioId' },
  { key: 'temControleJornada', label: 'Controle', href: '/v2/jornada-medicao', idParam: 'usuarioId' },
  { key: 'temHistorico', label: 'Inspeção', href: '/v2/nsirs', idParam: 'inspetorId' },
];

export const FONTE_USO_MUTUO = {
  key: 'usoMutuoNoDia',
  label: 'Uso mútuo',
  href: '/v2/nsirs',
  idParam: 'inspetorId',
};

export const FRASES_CURTAS = {
  JORNADA_FORA_DA_REGUA: 'Registrou ponto num dia em que essa pessoa não deveria trabalhar (domingo, feriado ou fora da convocação).',
  PROGRAMACAO_SEM_REGISTRO: 'Estava na programação e não registrou ponto nem fez inspeção.',
  CONTROLE_SEM_USO_MUTUO: 'Tem controle de jornada e não há inspeção de uso mútuo.',
  HISTORICO_ORFAO: 'Trabalhou na inspeção sem programação, ponto nem convocação.',
  CAMPO_SEM_PONTO: 'Trabalhou na inspeção, estava programado e não registrou o ponto.',
  INTERMITENTE_SEM_PONTO: 'Foi convocado e não registrou o ponto. Fica mais grave se também fez a inspeção.',
  INTERMITENTE_SEM_CONVOCACAO: 'Registrou ponto sem convocação aceita.',
  INTERMITENTE_PROGRAMADO_SEM_CONVOCACAO: 'Entrou na programação sem convocação aceita.',
  USO_MUTUO_CONTROLE_FALTANTE: 'Dia de uso mútuo sem controle de jornada.',
  JORNADA_SEM_PROGRAMACAO: 'Registrou ponto sem programação no dia.',
  AUSENCIA_JUSTIFICADA_COM_ATIVIDADE: 'Marcou ausência no mesmo dia em que há programação, convocação ou inspeção.',
};

const FONTES_CLASSIFICACAO = {
  JORNADA_FORA_DA_REGUA: {
    decide: ['temFolhaPonto', 'temControleJornada'],
    contexto: ['temProgramacao'],
    atalhos: ['temFolhaPonto', 'temProgramacao'],
    omit: ({ regimeKey, row }) => {
      const omit = [];
      if (regimeKey !== 'INTERMITENTE') omit.push('temConvocacao');
      if (!row?.temHistorico) omit.push('temHistorico');
      return omit;
    },
  },
  PROGRAMACAO_SEM_REGISTRO: {
    decide: ['temProgramacao', 'temFolhaPonto', 'temHistorico'],
    contexto: [],
    atalhos: ['temProgramacao', 'temFolhaPonto'],
    omit: ({ regimeKey }) => (regimeKey !== 'INTERMITENTE' ? ['temConvocacao'] : []),
  },
  CONTROLE_SEM_USO_MUTUO: {
    decide: ['temControleJornada', 'usoMutuoNoDia'],
    contexto: ['temFolhaPonto'],
    atalhos: ['temControleJornada', 'temHistorico'],
    omit: () => ['temConvocacao', 'temProgramacao', 'temHistorico'],
  },
  HISTORICO_ORFAO: {
    decide: ['temHistorico', 'temProgramacao', 'temFolhaPonto', 'temConvocacao'],
    contexto: [],
    atalhos: ['temHistorico', 'temProgramacao', 'temFolhaPonto'],
    omit: ({ row }) => (row?.temControleJornada ? [] : ['temControleJornada']),
  },
  CAMPO_SEM_PONTO: {
    decide: ['temHistorico', 'temProgramacao', 'temFolhaPonto'],
    contexto: [],
    atalhos: ['temHistorico', 'temFolhaPonto'],
  },
  INTERMITENTE_SEM_PONTO: {
    decide: ['temConvocacao', 'temFolhaPonto'],
    contexto: ['temHistorico'],
    atalhos: ['temConvocacao', 'temFolhaPonto'],
  },
  INTERMITENTE_SEM_CONVOCACAO: {
    decide: ['temFolhaPonto', 'temConvocacao'],
    contexto: [],
    atalhos: ['temFolhaPonto', 'temConvocacao'],
  },
  INTERMITENTE_PROGRAMADO_SEM_CONVOCACAO: {
    decide: ['temProgramacao', 'temConvocacao'],
    contexto: [],
    atalhos: ['temProgramacao', 'temConvocacao'],
  },
  USO_MUTUO_CONTROLE_FALTANTE: {
    decide: ['usoMutuoNoDia', 'temControleJornada'],
    contexto: ['temFolhaPonto'],
    atalhos: ['temHistorico', 'temControleJornada'],
  },
  JORNADA_SEM_PROGRAMACAO: {
    decide: ['temFolhaPonto', 'temControleJornada', 'temProgramacao'],
    contexto: [],
    atalhos: ['temFolhaPonto', 'temProgramacao'],
  },
  AUSENCIA_JUSTIFICADA_COM_ATIVIDADE: {
    decide: ['temFolhaPonto', 'temProgramacao', 'temConvocacao', 'temHistorico'],
    contexto: [],
    atalhos: ['temFolhaPonto', 'temProgramacao', 'temHistorico'],
  },
};

const DIA_SEMANA_LABEL = {
  DOMINGO: 'Domingo',
  SEGUNDA: 'Segunda',
  TERCA: 'Terça',
  QUARTA: 'Quarta',
  QUINTA: 'Quinta',
  SEXTA: 'Sexta',
  SABADO: 'Sábado',
};

export const fraseCurta = (codigo) => FRASES_CURTAS[codigo] || TIPOS[codigo]?.label || codigo || '—';

const fontePorKey = (key) => {
  if (key === FONTE_USO_MUTUO.key) return FONTE_USO_MUTUO;
  return FONTES.find((fonte) => fonte.key === key) || null;
};

const specDaClassificacao = (codigo) => FONTES_CLASSIFICACAO[codigo] || {
  decide: FONTES.map((fonte) => fonte.key),
  contexto: [],
  atalhos: FONTES.map((fonte) => fonte.key),
};

const ESPERADO_PRESENTE = {
  JORNADA_FORA_DA_REGUA: [],
  PROGRAMACAO_SEM_REGISTRO: ['temFolhaPonto', 'temHistorico'],
  CONTROLE_SEM_USO_MUTUO: ['usoMutuoNoDia'],
  HISTORICO_ORFAO: ['temProgramacao', 'temFolhaPonto', 'temConvocacao'],
  CAMPO_SEM_PONTO: ['temFolhaPonto'],
  INTERMITENTE_SEM_PONTO: ['temFolhaPonto'],
  INTERMITENTE_SEM_CONVOCACAO: ['temConvocacao'],
  INTERMITENTE_PROGRAMADO_SEM_CONVOCACAO: ['temConvocacao'],
  USO_MUTUO_CONTROLE_FALTANTE: ['temControleJornada'],
  JORNADA_SEM_PROGRAMACAO: ['temProgramacao'],
  AUSENCIA_JUSTIFICADA_COM_ATIVIDADE: [],
};

export const fontesDaRegra = (codigo, row, regimeKey) => {
  const spec = specDaClassificacao(codigo);
  const omit = spec.omit ? spec.omit({ row, regimeKey }) : [];
  const toFonte = (key, papel) => {
    const meta = fontePorKey(key);
    if (!meta || omit.includes(key)) return null;
    return { ...meta, papel, presente: Boolean(row?.[key]) };
  };
  const decide = spec.decide.map((key) => toFonte(key, 'decide')).filter(Boolean);
  const contexto = (spec.contexto || []).map((key) => toFonte(key, 'contexto')).filter(Boolean);
  const visiveis = [...decide, ...contexto];
  return {
    tem: visiveis.filter((fonte) => fonte.presente),
    falta: visiveis.filter((fonte) => !fonte.presente),
    atalhos: (spec.atalhos || []).map(fontePorKey).filter(Boolean),
  };
};

/** Inventário das 5 fontes (+ uso mútuo quando a regra usa). Layout C. */
export const inventarioDia = (codigo, row) => {
  const esperado = ESPERADO_PRESENTE[codigo] || [];
  const keys = FONTES.map((fonte) => fonte.key);
  if (
    esperado.includes('usoMutuoNoDia')
    || codigo === 'CONTROLE_SEM_USO_MUTUO'
    || codigo === 'USO_MUTUO_CONTROLE_FALTANTE'
  ) {
    keys.push(FONTE_USO_MUTUO.key);
  }
  const tem = [];
  const falta = [];
  keys.forEach((key) => {
    const meta = fontePorKey(key);
    if (!meta) return;
    const presente = Boolean(row?.[key]);
    const ruim = !presente && esperado.includes(key);
    const item = {
      ...meta,
      presente,
      ruim,
      nota: ruim ? `${meta.label} ausente — esperada neste dia.` : null,
    };
    if (presente) tem.push(item);
    else falta.push(item);
  });
  return { tem, falta };
};

export const formatDiaTitulo = (row) => {
  if (!row?.dia) return '—';
  const m = moment(row.dia, URL_DATE_FORMAT);
  const data = m.format('DD/MM');
  const semana = labelDiaSemana(row.diaSemana) || m.locale('pt-br').format('dddd');
  const semanaLabel = semana.charAt(0).toUpperCase() + semana.slice(1).toLowerCase();
  return `${semanaLabel} ${data}`;
};

const listarNomes = (fontes) => {
  const nomes = (fontes || []).map((fonte) => fonte.label);
  if (!nomes.length) return '';
  if (nomes.length === 1) return nomes[0];
  return `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`;
};

export const labelDiaSemana = (value) => {
  if (!value) return null;
  const key = String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  return DIA_SEMANA_LABEL[key] || null;
};

export const vereditoDoDia = (row, codigo, regimeKey) => {
  const data = row?.dia ? moment(row.dia, URL_DATE_FORMAT).format('DD/MM') : '—';
  const semana = labelDiaSemana(row?.diaSemana);
  const quando = semana ? `${semana} ${data}` : data;
  const { tem } = fontesDaRegra(codigo, row, regimeKey);
  const decideTem = tem.filter((fonte) => fonte.papel === 'decide');
  const temLabel = listarNomes(decideTem) || listarNomes(tem);
  if (codigo === 'JORNADA_FORA_DA_REGUA') {
    if (regimeKey === 'INTERMITENTE') {
      return `${quando} — tem ${temLabel || 'jornada'} fora do período convocado.`;
    }
    return `${quando} — tem ${temLabel || 'jornada'}. Indeterminado não espera jornada nesse dia.`;
  }
  if (codigo === 'PROGRAMACAO_SEM_REGISTRO') {
    return `${quando} — estava na programação e faltam o ponto e a inspeção.`;
  }
  if (codigo === 'CONTROLE_SEM_USO_MUTUO') {
    return `${quando} — tem controle de jornada e não há inspeção de uso mútuo.`;
  }
  if (codigo === 'HISTORICO_ORFAO') {
    return `${quando} — trabalhou na inspeção sem programação, ponto nem convocação.`;
  }
  if (codigo === 'CAMPO_SEM_PONTO') {
    return `${quando} — trabalhou na inspeção, estava na programação e não registrou o ponto.`;
  }
  if (codigo === 'INTERMITENTE_SEM_PONTO') {
    return row?.temHistorico
      ? `${quando} — convocado, sem ponto, e fez a inspeção.`
      : `${quando} — convocado e sem ponto.`;
  }
  if (codigo === 'INTERMITENTE_SEM_CONVOCACAO') {
    return `${quando} — registrou ponto sem convocação aceita.`;
  }
  if (codigo === 'INTERMITENTE_PROGRAMADO_SEM_CONVOCACAO') {
    return `${quando} — estava na programação sem convocação aceita.`;
  }
  if (codigo === 'USO_MUTUO_CONTROLE_FALTANTE') {
    return `${quando} — dia de uso mútuo sem controle de jornada.`;
  }
  if (codigo === 'JORNADA_SEM_PROGRAMACAO') {
    return `${quando} — tem ponto sem programação.`;
  }
  if (codigo === 'AUSENCIA_JUSTIFICADA_COM_ATIVIDADE') {
    return `${quando} — folha de ausência no mesmo dia em que há atividade.`;
  }
  return temLabel ? `${quando} — tem ${temLabel}.` : quando;
};

export const buildDestinoHref = (fonte, { usuarioId, inicio, fim }) => {
  const params = new URLSearchParams();
  if (usuarioId) params.set(fonte.idParam, usuarioId);
  if (inicio) params.set('inicio', moment(inicio).format('YYYY-MM-DD'));
  if (fim) params.set('fim', moment(fim).format('YYYY-MM-DD'));
  const search = params.toString();
  return search ? `${fonte.href}?${search}` : fonte.href;
};

/** Ciclo 26→25. Cópia local — não importar de RelatorioJornada. */
export const getMedicaoPeriod = (ref = moment()) => {
  const m = moment(ref);
  const day = m.date();
  let inicio;
  let fim;
  if (day >= 26) {
    inicio = m.clone().date(26).startOf('day');
    fim = m.clone().add(1, 'month').date(25).endOf('day');
  } else {
    inicio = m.clone().subtract(1, 'month').date(26).startOf('day');
    fim = m.clone().date(25).endOf('day');
  }
  return { inicio: inicio.valueOf(), fim: fim.valueOf() };
};

export const getPreviousMedicaoPeriod = (ref = moment()) => {
  const current = getMedicaoPeriod(ref);
  return getMedicaoPeriod(moment(current.inicio).subtract(1, 'day'));
};

const sameCalendarDay = (a, b) => moment(a).format(URL_DATE_FORMAT) === moment(b).format(URL_DATE_FORMAT);

export const periodForCiclo = (ciclo, ref = moment()) => (
  ciclo === CICLO_PASSADO ? getPreviousMedicaoPeriod(ref) : getMedicaoPeriod(ref)
);

export const applyCicloToFilter = (filter) => {
  const ciclo = filter?.ciclo || CICLO_ATUAL;
  if (ciclo === CICLO_CUSTOM) return { ...filter, ciclo };
  const period = periodForCiclo(ciclo);
  return { ...filter, ciclo, inicio: period.inicio, fim: period.fim };
};

export const getDefaultView = () => {
  const period = getMedicaoPeriod();
  return {
    ciclo: CICLO_ATUAL,
    inicio: period.inicio,
    fim: period.fim,
    regime: 'GERAL',
    inspetorId: null,
    visao: null,
  };
};

export const inferCiclo = (inicio, fim) => {
  const atual = getMedicaoPeriod();
  const passado = getPreviousMedicaoPeriod();
  if (sameCalendarDay(inicio, atual.inicio) && sameCalendarDay(fim, atual.fim)) return CICLO_ATUAL;
  if (sameCalendarDay(inicio, passado.inicio) && sameCalendarDay(fim, passado.fim)) return CICLO_PASSADO;
  return CICLO_CUSTOM;
};

const parseEpochDate = (value, boundary) => {
  if (!value) return null;
  const parsed = moment(value, URL_DATE_FORMAT, true);
  if (!parsed.isValid()) return null;
  return boundary === 'end' ? parsed.endOf('day').valueOf() : parsed.startOf('day').valueOf();
};

export const parseViewFromSearch = (search, fallback = getDefaultView()) => {
  const q = new URLSearchParams(search || '');
  const view = { ...fallback };
  const inicio = parseEpochDate(q.get('inicio'), 'start');
  const fim = parseEpochDate(q.get('fim'), 'end');
  if (inicio != null) view.inicio = inicio;
  if (fim != null) view.fim = fim;
  const cicloParam = q.get('ciclo');
  if (cicloParam === CICLO_ATUAL || cicloParam === CICLO_PASSADO || cicloParam === CICLO_CUSTOM) {
    view.ciclo = cicloParam;
  } else {
    view.ciclo = inferCiclo(view.inicio, view.fim);
  }
  if (view.ciclo !== CICLO_CUSTOM) {
    const period = periodForCiclo(view.ciclo);
    view.inicio = period.inicio;
    view.fim = period.fim;
  }
  const regime = q.get('regime');
  view.regime = regime === 'INTERMITENTE' || regime === 'INDETERMINADO' ? regime : 'GERAL';
  view.inspetorId = q.get('inspetorId') || null;
  const visao = q.get('visao');
  view.visao = visao === 'calendario' || visao === 'resumo' ? visao : null;
  return view;
};

export const buildSearchFromView = (view) => {
  const q = new URLSearchParams();
  if (view?.ciclo) q.set('ciclo', view.ciclo);
  if (view?.inicio != null) q.set('inicio', moment(view.inicio).format(URL_DATE_FORMAT));
  if (view?.fim != null) q.set('fim', moment(view.fim).format(URL_DATE_FORMAT));
  if (view?.regime && view.regime !== 'GERAL') q.set('regime', view.regime);
  if (view?.inspetorId) q.set('inspetorId', view.inspetorId);
  if (view?.visao === 'calendario' || view?.visao === 'resumo') q.set('visao', view.visao);
  return q.toString();
};

/** Deep link / navegação a partir do compliance de jornada (já filtrado no inspetor). */
export const buildConformidadeInspecaoUrl = ({
  inicio,
  fim,
  ciclo,
  inspetorId,
  visao = 'resumo',
} = {}) => {
  const q = new URLSearchParams();
  if (ciclo) q.set('ciclo', ciclo);
  if (inicio != null) q.set('inicio', moment(inicio).format(URL_DATE_FORMAT));
  if (fim != null) q.set('fim', moment(fim).format(URL_DATE_FORMAT));
  if (inspetorId) q.set('inspetorId', String(inspetorId));
  if (visao === 'calendario' || visao === 'resumo') q.set('visao', visao);
  const qs = q.toString();
  return qs ? `/v2/relatorio-conformidade-inspecao?${qs}` : '/v2/relatorio-conformidade-inspecao';
};

export const viewsEqual = (a, b) => buildSearchFromView(a) === buildSearchFromView(b);

export const formatPeriodLabel = (inicio, fim) => {
  if (inicio == null || fim == null) return '';
  return `${moment(inicio).format('DD/MM/YYYY')} – ${moment(fim).format('DD/MM/YYYY')}`;
};

export const isPeriodInvalid = (inicio, fim) => {
  if (inicio == null || fim == null) return true;
  return moment(inicio).startOf('day').isAfter(moment(fim).endOf('day'));
};

export const labelTipo = (codigo) => TIPOS[codigo]?.label || codigo || '—';
export const chipCurto = (codigo) => TIPOS[codigo]?.chip || codigo || '—';

export const significadoCompleto = (codigo) => {
  const item = LEGENDA_CLASSIFICACAO.find((entrada) => entrada.codigo === codigo);
  return item?.significa || fraseCurta(codigo);
};

export const REGIME_TABS = [
  { id: 'GERAL', label: 'Geral' },
  { id: 'INTERMITENTE', label: 'Intermitente' },
  { id: 'INDETERMINADO', label: 'Indeterminado' },
];

export const regimeKey = (value) => {
  const text = String(value || '').toUpperCase();
  if (text.startsWith('INTERMIT')) return 'INTERMITENTE';
  if (text.startsWith('INDETERMIN') || text.startsWith('INTERMIN')) return 'INDETERMINADO';
  return null;
};

export const labelRegime = (value) => {
  const key = regimeKey(value);
  if (key === 'INTERMITENTE') return 'Intermitente';
  if (key === 'INDETERMINADO') return 'Indeterminado';
  return value || '—';
};

export const filterPessoasPorRegime = (pessoas, regime) => {
  if (!regime || regime === 'GERAL') return pessoas || [];
  return (pessoas || []).filter((pessoa) => pessoa.regimeKey === regime);
};

export const labelSeveridade = (value) => {
  if (value === 'ALTA') return 'Alta';
  if (value === 'MEDIA') return 'Média';
  if (value === 'BAIXA') return 'Baixa';
  return null;
};

const rankSeveridade = (value) => (SEVERIDADE_RANK[value] == null ? 9 : SEVERIDADE_RANK[value]);

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const normalizePartes = (porClassificacao) => {
  if (Array.isArray(porClassificacao)) {
    return porClassificacao
      .map((parte) => ({
        codigo: parte?.codigo || parte?.classificacao,
        severidade: parte?.severidade || null,
        dias: toNumber(parte?.dias),
      }))
      .filter((parte) => parte.codigo && parte.codigo !== 'OK');
  }
  if (porClassificacao && typeof porClassificacao === 'object') {
    return Object.keys(porClassificacao)
      .filter((codigo) => codigo && codigo !== 'OK')
      .map((codigo) => ({
        codigo,
        severidade: null,
        dias: toNumber(porClassificacao[codigo]),
      }));
  }
  return [];
};

const normalizeProblemas = (problemas) => {
  if (!Array.isArray(problemas)) return [];
  return problemas
    .map((problema) => ({
      codigo: problema?.codigo,
      severidade: problema?.severidade || null,
      pessoas: toNumber(problema?.pessoas),
    }))
    .filter((problema) => problema.codigo)
    .sort((a, b) => rankSeveridade(a.severidade) - rankSeveridade(b.severidade) || b.pessoas - a.pessoas);
};

export const chipsDoDia = (problemas, { pessoal = false } = {}) => {
  const lista = normalizeProblemas(problemas);
  if (pessoal) {
    return lista.map((problema) => ({
      key: `${problema.codigo}|${problema.severidade || ''}`,
      label: labelTipo(problema.codigo),
      title: significadoCompleto(problema.codigo),
      severidade: problema.severidade,
    }));
  }
  const visiveis = lista.slice(0, 2).map((problema) => ({
    key: problema.codigo,
    label: `${chipCurto(problema.codigo)} · ${problema.pessoas}`,
    title: significadoCompleto(problema.codigo),
    severidade: problema.severidade,
  }));
  if (lista.length > 2) {
    const extras = lista.slice(2).map((problema) => `${labelTipo(problema.codigo)} — ${significadoCompleto(problema.codigo)}`);
    visiveis.push({ key: 'mais', label: `+${lista.length - 2}`, title: extras.join(' · ') });
  }
  return visiveis;
};

export const piorSeveridade = (problemas, fallback) => {
  const lista = normalizeProblemas(problemas);
  if (!lista.length) return fallback || null;
  return lista.slice().sort((a, b) => rankSeveridade(a.severidade) - rankSeveridade(b.severidade))[0].severidade
    || fallback
    || null;
};

const piorDeClassificacoes = (classificacoes) => {
  if (!classificacoes.length) return null;
  return classificacoes.slice().sort((a, b) => rankSeveridade(a.severidade) - rankSeveridade(b.severidade))[0].severidade
    || null;
};

const ordenarClassificacoes = (classificacoes) => [...(classificacoes || [])].sort((a, b) => {
  const bySev = rankSeveridade(a.severidade) - rankSeveridade(b.severidade);
  if (bySev !== 0) return bySev;
  return String(a.tipo || '').localeCompare(String(b.tipo || ''), 'pt-BR', { sensitivity: 'base' });
});

const toClassificacao = (parte) => ({
  codigo: parte.codigo,
  tipo: labelTipo(parte.codigo),
  severidade: parte.severidade,
  dias: parte.dias,
});

const classificacoesDaLinhaFiltro = (row) => {
  const classificacoes = Array.isArray(row.classificacoes) ? row.classificacoes : [];
  return classificacoes
    .map((item) => {
      const codigo = typeof item === 'string' ? item : item?.codigo;
      if (!codigo || codigo === 'OK') return null;
      return {
        codigo,
        tipo: labelTipo(codigo),
        severidade: typeof item === 'string' ? null : (item.severidade || null),
        dias: 1,
      };
    })
    .filter(Boolean);
};

export const pessoasFromFilterRows = (rows) => {
  const map = new Map();
  (rows || []).forEach((row) => {
    const usuarioId = row?.usuarioId;
    const key = usuarioId || row?.usuarioNome;
    if (!key) return;
    if (!map.has(key)) {
      map.set(key, {
        usuarioId,
        usuarioNome: row.usuarioNome || '—',
        regime: labelRegime(row.regimeTrabalho),
        regimeKey: regimeKey(row.regimeTrabalho),
        diasVistos: new Set(),
        classificacoesMap: new Map(),
        estimado: false,
      });
    }
    const pessoa = map.get(key);
    if (row.dia) pessoa.diasVistos.add(row.dia);
    classificacoesDaLinhaFiltro(row).forEach((parte) => {
      const parteKey = `${parte.codigo}|${parte.severidade || ''}`;
      const atual = pessoa.classificacoesMap.get(parteKey) || { ...parte, dias: 0 };
      atual.dias += 1;
      pessoa.classificacoesMap.set(parteKey, atual);
    });
  });
  return [...map.values()].map((pessoa) => {
    const classificacoes = ordenarClassificacoes([...pessoa.classificacoesMap.values()]);
    return {
      usuarioId: pessoa.usuarioId,
      usuarioNome: pessoa.usuarioNome,
      regime: pessoa.regime,
      regimeKey: pessoa.regimeKey,
      diasComOcorrencia: pessoa.diasVistos.size,
      classificacoes,
      piorSeveridade: piorDeClassificacoes(classificacoes),
      estimado: pessoa.estimado,
    };
  });
};

export const calendarioFromFilterRows = (rows) => {
  const byDay = new Map();
  (rows || []).forEach((row) => {
    if (!row?.dia) return;
    const problemas = classificacoesDaLinhaFiltro(row).map((parte) => ({
      codigo: parte.codigo,
      severidade: parte.severidade,
      pessoas: 1,
    }));
    byDay.set(row.dia, {
      dia: row.dia,
      severidade: piorDeClassificacoes(problemas),
      problemas,
    });
  });
  return [...byDay.values()];
};

export const calendarioEmpresaFromFilterRows = (rows, regime) => {
  const byDay = new Map();
  (rows || []).forEach((row) => {
    if (!row?.dia) return;
    if (regime && regime !== 'GERAL' && regimeKey(row.regimeTrabalho) !== regime) return;
    const problemas = classificacoesDaLinhaFiltro(row);
    if (!problemas.length) return;
    if (!byDay.has(row.dia)) byDay.set(row.dia, new Map());
    const codes = byDay.get(row.dia);
    problemas.forEach((parte) => {
      const key = `${parte.codigo}|${parte.severidade || ''}`;
      if (!codes.has(key)) {
        codes.set(key, {
          codigo: parte.codigo,
          severidade: parte.severidade,
          usuarios: new Set(),
        });
      }
      const bucket = codes.get(key);
      if (rankSeveridade(parte.severidade) < rankSeveridade(bucket.severidade)) {
        bucket.severidade = parte.severidade;
      }
      if (row.usuarioId) bucket.usuarios.add(row.usuarioId);
    });
  });
  return [...byDay.entries()].map(([dia, codes]) => {
    const problemas = [...codes.values()].map((item) => ({
      codigo: item.codigo,
      severidade: item.severidade,
      pessoas: item.usuarios.size || 1,
    }));
    return {
      dia,
      severidade: piorDeClassificacoes(problemas),
      problemas,
    };
  });
};

export const sortPessoas = (pessoas, field, direction) => {
  const dir = direction === 'desc' ? -1 : 1;
  return [...(pessoas || [])].sort((a, b) => {
    if (field === 'dias') return dir * (a.diasComOcorrencia - b.diasComOcorrencia);
    if (field === 'severidade') {
      const bySev = rankSeveridade(a.piorSeveridade) - rankSeveridade(b.piorSeveridade);
      if (bySev !== 0) return dir * bySev;
      return String(a.usuarioNome || '').localeCompare(String(b.usuarioNome || ''), 'pt-BR', { sensitivity: 'base' });
    }
    if (field === 'regime') {
      const byRegime = String(a.regime || '').localeCompare(String(b.regime || ''), 'pt-BR', { sensitivity: 'base' });
      if (byRegime !== 0) return dir * byRegime;
      return String(a.usuarioNome || '').localeCompare(String(b.usuarioNome || ''), 'pt-BR', { sensitivity: 'base' });
    }
    return dir * String(a.usuarioNome || '').localeCompare(String(b.usuarioNome || ''), 'pt-BR', { sensitivity: 'base' });
  });
};

export const normalizeResumo = (payload) => {
  const raw = payload?.data && !Array.isArray(payload.data) && payload.data.items
    ? payload.data
    : (payload || {});
  const items = Array.isArray(raw.items) ? raw.items : [];
  const calendario = Array.isArray(raw.calendario) ? raw.calendario : null;
  const pessoas = items.map((item) => {
    const classificacoes = ordenarClassificacoes(normalizePartes(item.porClassificacao).map(toClassificacao));
    return {
      usuarioId: item.usuarioId,
      usuarioNome: item.usuarioNome || '—',
      regime: labelRegime(item.regimeTrabalho),
      regimeKey: regimeKey(item.regimeTrabalho),
      diasComOcorrencia: toNumber(item.diasComOcorrencia),
      classificacoes,
      piorSeveridade: piorDeClassificacoes(classificacoes),
      estimado: Boolean(item.estimado),
    };
  });
  const linhas = pessoas.flatMap((pessoa) => pessoa.classificacoes.map((parte) => ({
    usuarioId: pessoa.usuarioId,
    usuarioNome: pessoa.usuarioNome,
    regime: pessoa.regime,
    codigo: parte.codigo,
    tipo: parte.tipo,
    severidade: parte.severidade,
    dias: parte.dias,
    estimado: pessoa.estimado,
  })));
  linhas.sort((a, b) => rankSeveridade(a.severidade) - rankSeveridade(b.severidade) || b.dias - a.dias);
  const dias = (calendario || []).map((dia) => ({
    dia: dia.dia,
    severidade: piorSeveridade(dia.problemas, dia.severidade),
    problemas: normalizeProblemas(dia.problemas),
  }));
  return {
    linhas,
    pessoas,
    calendario: dias,
    semSerie: calendario == null,
    semSeveridade: linhas.some((linha) => !linha.severidade),
  };
};

export const agruparFilterRowsPorClassificacao = (rows) => {
  const map = new Map();
  (rows || []).forEach((row) => {
    classificacoesDaLinhaFiltro(row).forEach((parte) => {
      const key = `${parte.codigo}|${parte.severidade || ''}`;
      if (!map.has(key)) {
        map.set(key, {
          codigo: parte.codigo,
          tipo: parte.tipo,
          severidade: parte.severidade,
          chip: chipCurto(parte.codigo),
          frase: fraseCurta(parte.codigo),
          dias: [],
        });
      }
      map.get(key).dias.push(row);
    });
  });
  return [...map.values()].sort((a, b) => {
    const bySev = rankSeveridade(a.severidade) - rankSeveridade(b.severidade);
    if (bySev !== 0) return bySev;
    return String(a.tipo || '').localeCompare(String(b.tipo || ''), 'pt-BR', { sensitivity: 'base' });
  });
};

export const explodeFilterRows = (rows) => {
  const linhas = [];
  (rows || []).forEach((row) => {
    const classificacoes = Array.isArray(row.classificacoes) ? row.classificacoes : [];
    classificacoes.forEach((item) => {
      const codigo = typeof item === 'string' ? item : item?.codigo;
      if (!codigo || codigo === 'OK') return;
      linhas.push({
        usuarioId: row.usuarioId,
        usuarioNome: row.usuarioNome || '—',
        regime: labelRegime(row.regimeTrabalho),
        codigo,
        tipo: labelTipo(codigo),
        severidade: typeof item === 'string' ? null : (item.severidade || null),
        dias: 1,
        estimado: false,
        dia: row.dia,
      });
    });
  });
  return linhas.sort((a, b) => rankSeveridade(a.severidade) - rankSeveridade(b.severidade));
};

export const countDiasCiclo = (inicio, fim) => {
  const start = moment(inicio).startOf('day');
  const end = moment(fim).startOf('day');
  if (!start.isValid() || !end.isValid() || start.isAfter(end)) return 0;
  return end.diff(start, 'days') + 1;
};

export const buildApiBody = (inicio, fim, extra = {}) => ({
  inicio,
  fim,
  usuarioIds: null,
  classificacoes: null,
  ...extra,
});
